var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealTimeBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.2,
    height: 93.951,
    viewBox: "0 0 93.2 93.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.23,110.3c-3.88-5.18-14.56-10.35-8.73-17.79a44.72,44.72,0,0,0,9.7-27.82A46.12,46.12,0,0,0,58.94,19.07,45.63,45.63,0,0,0,13,64.68a46.11,46.11,0,0,0,45.94,45.94c3.56,0,10.35.32,10.35.32l25.23,1h.65c1.62,0,11,.65,9.06-1.62",
    transform: "translate(-12.5 -18.57)",
    fill: "#fff",
    stroke: "#d1d1d1",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.29,87.33a3.84,3.84,0,0,0,3.88-3.23A18.3,18.3,0,0,1,77.7,68.57a3.92,3.92,0,0,0-1-7.76,26.32,26.32,0,0,0-14.56,7.44A27.42,27.42,0,0,0,54.73,82.8C54.41,85.39,56,87.33,58.29,87.33ZM47,53A47.45,47.45,0,0,0,33.06,82.15,4.26,4.26,0,0,0,37.26,87a4,4,0,0,0,4.21-3.88A39.3,39.3,0,0,1,76.73,47.86a4.22,4.22,0,0,0,3.88-4.21,4.7,4.7,0,0,0-4.85-4.53A49.3,49.3,0,0,0,47,53Z",
    transform: "translate(-12.5 -18.57)",
    fill: "#9c0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeBadge);
export default __webpack_public_path__ + "static/media/real-time-badge.22999baf78eed599603e262a852e59c4.svg";
export { ForwardRef as ReactComponent };